class h {
  constructor(t = {}) {
    ((this.maxSize = t.maxSize || 50),
      (this.ttlMs = t.ttlMs || 3e5),
      (this.cache = new Map()),
      (this.timestamps = new Map()));
  }
  get(t) {
    if (this.timestamps.has(t)) {
      const e = this.timestamps.get(t);
      if (Date.now() - e > this.ttlMs) {
        this.delete(t);
        return;
      }
    }
    return this.cache.get(t);
  }
  set(t, e) {
    (this.cache.size >= this.maxSize && !this.cache.has(t) && this.#t(),
      this.cache.set(t, e),
      this.timestamps.set(t, Date.now()));
  }
  has(t) {
    if (!this.cache.has(t)) return !1;
    const e = this.timestamps.get(t);
    return Date.now() - e > this.ttlMs ? (this.delete(t), !1) : !0;
  }
  delete(t) {
    (this.cache.delete(t), this.timestamps.delete(t));
  }
  clear() {
    (this.cache.clear(), this.timestamps.clear());
  }
  get size() {
    return this.cache.size;
  }
  #t() {
    let t = null,
      e = 1 / 0;
    for (const [i, s] of this.timestamps) s < e && ((e = s), (t = i));
    t && this.delete(t);
  }
}
export { h as B };
